import { SERVICE } from './constants'

export const SET_CUPS_SEARCHER_BY_CUPS = `${SERVICE}/SET_CUPS_SEARCHER_BY_CUPS`
export const CLEAR_CUPS_SEARCHER_BY_CUP = `${SERVICE}/CLEAR_CUPS_SEARCHER_BY_CUP`
